"use strict";

// TODO: remove after https://github.com/bem/babel-plugin-bem-import/issues/30
module.exports = {
    "m-footer": {
        "feedback": "Feedback",
        "confidential": "Confidential",
        "guide": "Guide",
        "about": "About",
        "yandex_info": "Trade secrets of Yandex LLC. 16, Lev Tolstoy Str., Moscow, Russia, 119021",
        "mobile": "Mobile version"
    }
};